module.exports = __webpack_public_path__ + "media/images/front/event/dummythumb1-f19042699f38da7bbcb35323b7640a33.svg";